export const CONTACT_EMAIL = 'info@tpvhosty.com';

/** Número de WhatsApp (España, sin prefijo internacional). */
export const CONTACT_WHATSAPP = '613168251';

export const CONTACT_WHATSAPP_E164 = `34${CONTACT_WHATSAPP}`;

export const CONTACT_WHATSAPP_URL = `https://wa.me/${CONTACT_WHATSAPP_E164}`;

export const CONTACT_WHATSAPP_DISPLAY = `+34 ${CONTACT_WHATSAPP.slice(0, 3)} ${CONTACT_WHATSAPP.slice(3, 6)} ${CONTACT_WHATSAPP.slice(6)}`;

export const SOCIAL_URLS = {
  instagram: 'https://www.instagram.com/tpvhosty',
  facebook: 'https://www.facebook.com/hostypos',
  linkedin: 'https://www.linkedin.com/company/tpvhosty',
};
